import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function NormalFlowOffToOnCreditsNoEcomYes(props) {
  const { onClickCancel, postingId, isInmobiliaria } = props;
  const { t } = useTranslation();

  const url = isInmobiliaria
    ? `..${t('panel.url.ecommerce.professional')}?idPosting=${postingId}`
    : `..${t('panel.url.ecommerce.particular')}?idPosting=${postingId}`;

  useEffect(() => {
    sendTrackingInfo('Mis avisos', 'Republicar Aviso_sin credito-Intencion');
  }, []);

  return (
    <ModalInformation
      onClickAction={onClickCancel}
      onClickCancel={onClickCancel}
      onClickOutside={onClickCancel}
      title={t('panel.modal.NormalFlowOffToOnCreditsNoEcomYes.title')}
      ctaCancel={t('panel.modal.cta.cancel')}
      urlLink={url}
      ctaAnchor={t('panel.modal.cta.buyCredits')}
    />
  );
}

export { NormalFlowOffToOnCreditsNoEcomYes };
